import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { SurveysService } from '../surveys.service';

@Component({
  selector: 'app-evidence-thumbnail-view',
  templateUrl: './evidence-thumbnail-view.component.html',
  styleUrls: ['./evidence-thumbnail-view.component.scss'],
})
export class EvidenceThumbnailViewComponent implements OnInit, OnChanges {
  @Input() evidenceData: any[] = [];

  @Input() isLoading: boolean = false;

  @Input() noEvidenceMessage: string = '';

  @Input() evidenceType: string;

  @Output() evidenceClick = new EventEmitter<number>();

  constructor(private surveyService: SurveysService) {}

  ngOnInit(): void {
    this.loadImages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['evidenceData'] && changes['evidenceData'].currentValue) {
      this.loadImages();
    }
  }

  private loadImages(): void {
    this.evidenceData.forEach((evidence, index) => {
      if (!evidence['src'] && !evidence['imageLoading']) {
        this.loadImageForEvidence(evidence);
      }
    });
  }

  private loadImageForEvidence(evidence: any): void {
    // Set loading flag to prevent multiple requests
    evidence['imageLoading'] = true;

    // Construct fileName if it doesn't exist
    if (!evidence['fileName']) {
      evidence['fileName'] = `${
        evidence.surveyID || evidence.survey_id || ''
      }-${evidence.questionID || evidence.question_id || ''}-${
        evidence.storeID || evidence.store_id || ''
      }-${evidence.photoName || ''}`;
    }

    if (evidence['fileName'] && evidence['fileName'] !== '---') {
      this.surveyService
        .getPhotos(`?fileNames=${evidence['fileName']}`)
        .subscribe(
          (photoData) => {
            evidence['imageLoading'] = false;
            if (Object.keys(photoData).length === 0) {
              evidence['src'] = 'assets/images/placeholder-image.png';
            } else {
              evidence['src'] = photoData[evidence['fileName']];
            }
          },
          (error) => {
            evidence['imageLoading'] = false;
            evidence['src'] = 'assets/images/placeholder-image.png';
          }
        );
    } else {
      evidence['imageLoading'] = false;
      evidence['src'] = 'assets/images/placeholder-image.png';
    }
  }

  onEvidenceClick(index: number): void {
    this.evidenceClick.emit(index);
  }

  getImageUrl(evidence: any): string {
    // Return the loaded src or placeholder while loading
    return evidence['src'] || 'assets/images/placeholder-image.png';
  }

  getEvidenceTitle(evidence: any): string | null {
    return evidence.controlName || null;
  }

  getFindingTitle(evidence: any): string | null {
    return evidence.findingTitle || null;
  }

  getEvidenceDate(evidence: any): string | null {
    return evidence.date || evidence.createdDate || evidence.timestamp || null;
  }

  getStoreNumber(evidence: any): string | null {
    const storeNumber = evidence.storeID || null;
    const storeName = evidence.storeName || null;
    return storeNumber && storeName ? `${storeNumber} - ${storeName}` : storeNumber;
  }

  getAssessmentType(evidence: any): string | null {
    return evidence.surveyTitle || null;
  }

  getSectionHeading(evidence: any): string | null {
    return evidence.sectionHeading || null;
  }
}
